/* eslint-disable no-param-reassign */
import React from 'react';

import {
  Vector3,
} from '@babylonjs/core';
import '@babylonjs/loaders';

import Camera0AngleView from '../Resources/camera-view-0-deg.png';
import Camera90AngleView from '../Resources/camera-view-90-deg.png';
import CameraMinus90AngleView from '../Resources/camera-view-Minus90-deg.png';
import Camera180AngleView from '../Resources/camera-view-180-deg.png';
import Camera45AngleView from '../Resources/camera-view-45-deg.png';

type CameraViewWidgetParameters = {
  setCameraViewHandler: (cameraPosition: Vector3) => void;
};

export function CameraViewWidget({
  setCameraViewHandler,
} : CameraViewWidgetParameters) : JSX.Element {

  const sideCameraView = new Vector3(0, 0, 1);
  const oppositeCameraView = new Vector3(0, 0, -1);
  const frontCameraView = new Vector3(-1, 0, 0);
  const backCameraView = new Vector3(1, 0, 0);
  const angleCameraView = new Vector3(-1, 1, 1);

  return (
    <div
      style={{
        position: 'absolute', top: '80px', left: '0px', width: '50%', minWidth: '50px', maxWidth: '50px',
      }}
      className="container"
    >
      <div className="column">
        <div className="col-2">
          <button className="btn btn-outline-secondary" style={{ width: '40px', height: '40px', padding: '0px' }} type="button" onClick={() => { setCameraViewHandler(backCameraView); }}>
            <img
              src={CameraMinus90AngleView}
              style={{
                width: '40px', height: '40px',
              }}
              alt="-90º"
            />
          </button>
        </div>
        <div className="col-2">
          <button className="btn btn-outline-secondary" style={{ width: '40px', height: '40px', padding: '0px' }} type="button" onClick={() => { setCameraViewHandler(sideCameraView); }}>
            <img
              src={Camera0AngleView}
              style={{
                width: '40px', height: '40px',
              }}
              alt="90º"
            />
          </button>
        </div>
        <div className="col-2">
          <button className="btn btn-outline-secondary" style={{ width: '40px', height: '40px', padding: '0px' }} type="button" onClick={() => { setCameraViewHandler(angleCameraView); }}>
            <img
              src={Camera45AngleView}
              style={{
                width: '40px', height: '40px',
              }}
              alt="45º"
            />
          </button>
        </div>
        <div className="col-2">
          <button className="btn btn-outline-secondary" style={{ width: '40px', height: '40px', padding: '0px' }} type="button" onClick={() => { setCameraViewHandler(frontCameraView); }}>
            <img
              src={Camera90AngleView}
              style={{
                width: '40px', height: '40px',
              }}
              alt="90º"
            />
          </button>
        </div>
        <div className="col-2">
          <button className="btn btn-outline-secondary" style={{ width: '40px', height: '40px', padding: '0px' }} type="button" onClick={() => { setCameraViewHandler(oppositeCameraView); }}>
            <img
              src={Camera180AngleView}
              style={{
                width: '40px', height: '40px',
              }}
              alt="180º"
            />
          </button>
        </div>
      </div>
    </div>
  );
}
